// import * as common from '@/store/mutation-types';
export const APPR_REASON_INFO = 'APPR_REASON_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';

export default {
	// ...common,
	APPR_REASON_INFO,
	DEFAULT_ASSIGN
};
